module.exports = require('./src/video-worker.esm');



//////////////////
// WEBPACK FOOTER
// /Users/valentinocossar/Projects/cappellotto-new.com/app/public/wp-content/themes/cappellotto/node_modules/video-worker/index.js
// module id = 28
// module chunks = 0